'use strict';

var Enhancer = require('./enhancer');

module.exports = function (ComposedComponent) {
  return Enhancer(ComposedComponent);
};
module.exports.Style = require('./components/style');
module.exports.PrintStyleSheet = require('./components/print-style-sheet');
module.exports.getState = require('./get-state');
module.exports.keyframes = require('./keyframes');
module.exports.Config = require('./config');


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/index.js
 ** module id = 548
 ** module chunks = 46
 **/